import clsx from 'classnames'
import { MdWarningAmber } from 'react-icons/md'

import styles from './error-placeholder.module.css'

interface ErrorPlaceholderProps {
  title?: string
  message?: string
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function ErrorPlaceHolder ({
  title = 'Something went wrong',
  message,
  children,
  className,
  style
}: ErrorPlaceholderProps): JSX.Element {
  return (
    <div
      className={clsx(className, styles.wrapper)}
      style={style}
    >
      <div className={styles.container}>
        <MdWarningAmber
          size='1.4rem'
          color='#E4980F'
        />

        <div className={styles.title}>
          {title}
        </div>

        {message && (
          <p className={styles.message}>
            {message}
          </p>
        )}

        <div className={styles.children}>
          {children}
        </div>
      </div>
    </div>
  )
}
